import React from 'react';
import Radium from 'radium';
import Styles from './MapConnector.styles';
class JumperMapConnector extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.removeConnector = this.removeConnector.bind(this);
  }

  removeConnector() {
    this.props.onConnectorRemove(this.props.id);
  }

  render() {
    const box = this.props.containerRef;
    const endPositionX = this.props.endWidget
      ? this.props.endWidget.positionX
      : this.props.endPositionX;
    const endPositionY = this.props.endWidget
      ? this.props.endWidget.positionY
      : this.props.endPositionY;
    const startPositionX = this.props.startWidget
      ? this.props.startWidget.positionX
      : this.props.startPositionX;
    const startPositionY = this.props.startWidget
      ? this.props.startWidget.positionY
      : this.props.startPositionY;
    let height = 0;
    let angle = 0;
    if (box) {
      const boxCoord = box.getBoundingClientRect();
      const test =
        (endPositionX * boxCoord.width - startPositionX * boxCoord.width) ** 2 +
        (endPositionY * boxCoord.height - startPositionY * boxCoord.height) ** 2;
      height = Math.sqrt(test) / boxCoord.height;
      angle =
        Math.atan2(
          endPositionX * boxCoord.width - startPositionX * boxCoord.width,
          endPositionY * boxCoord.height - startPositionY * boxCoord.height,
        ) *
        180 /
        Math.PI *
        -1;
    }

    const selectedStyle = this.props.selected ? Styles.selectedStyle : {};
    return (
      <div
        className="JumperMapConnector"
        style={[
          Styles.lineStyle(
            startPositionX,
            endPositionX,
            startPositionY,
            endPositionY,
            angle,
            height,
          ),
          selectedStyle,
        ]}
      >
        {this.props.selected && (
          <div style={Styles.removeButtonWrapper}>
            <div style={Styles.removeButton} onClick={this.removeConnector}>
              <span className={'icon-scissors'} />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Radium(JumperMapConnector);



// WEBPACK FOOTER //
// ./src/components/Map/MapConnector/MapConnector.js